import { CSSProperties, useEffect, useState } from 'react';

import { isNullOrUndefined } from '../../utils/utils';
import { StatusTag } from './StatusTag';

type DockingReleaseType = 'PENDING' | 'RELEASED_WITH_PENDING' | 'RELEASED';

type DockingReleaseStatusProps = {
  dockingRelease?: DockingReleaseType;
  stopoverStatus?: string;
  // DOCKING deixa explícito que a liberação exibida é a desta atracação
  variant?: 'STOPOVER' | 'DOCKING';
  style?: CSSProperties;
};

const releaseStatus: Record<
  'STOPOVER' | 'DOCKING',
  Record<DockingReleaseType, { label: string; className: string }>
> = {
  STOPOVER: {
    PENDING: { label: 'liberação pendente', className: 'orange' },
    RELEASED_WITH_PENDING: {
      label: 'liberado com pendências',
      className: 'red',
    },
    RELEASED: { label: 'liberado', className: 'green' },
  },
  DOCKING: {
    PENDING: {
      label: 'atracação pendente de liberação',
      className: 'orange',
    },
    RELEASED_WITH_PENDING: {
      label: 'atracação liberada com pendências',
      className: 'green',
    },
    RELEASED: { label: 'atracação liberada', className: 'green' },
  },
};

export function DockingReleaseStatus(props: DockingReleaseStatusProps) {
  const { dockingRelease, stopoverStatus, variant, style } = props;

  const [label, setLabel] = useState('');
  const [className, setClassName] = useState('');

  useEffect(() => {
    if (!isNullOrUndefined(stopoverStatus) && stopoverStatus === 'CANCELED') {
      setClassName('red');
      setLabel('cancelada');
      return;
    }
    // No contexto da atracação a ausência de liberação significa pendente
    const release =
      dockingRelease || (variant === 'DOCKING' ? 'PENDING' : undefined);
    if (!release) return;
    const status = releaseStatus[variant || 'STOPOVER'][release];
    setLabel(status.label);
    setClassName(status.className);
  }, [stopoverStatus, dockingRelease, variant]);

  return (
    <StatusTag style={style}>
      <span className={className}>{label}</span>
    </StatusTag>
  );
}
